import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'

export const currencyRateApi = createApi({
    reducerPath: 'currencyRateApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: [],
    endpoints: builder => ({
        getCurrencyRates: builder.query<{ code: string; rate: number }[], void>({
            query: () => `/currency-rate`,
            transformResponse: (rates: { code: string; rate: string }[]) => {
                return rates.map(x => ({ code: x.code, rate: +x.rate.replace(',', '.') }))
            },
        }),
    }),
})

export const { useGetCurrencyRatesQuery } = currencyRateApi
